import React, { Component } from 'react';
import { Button, Carousel } from 'react-bootstrap';
import hgIcon from '../assets/icons/hydrogeology-icon.png';
import bgcIcon from '../assets/icons/biogeochemistry-icon.png';
import vIcon from '../assets/icons/vegetation-icon.png';
import cIcon from '../assets/icons/climate-icon.png';
import mIcon from '../assets/icons/modeloutput-icon.png';
import ecoIcon from '../assets/icons/vegetation-icon.png';
import './SitesPane.css';


const icons = {
    hydrogeology: [0, hgIcon],
    ecohydrology: [1, ecoIcon],
    biogeochemistry: [2, bgcIcon],
    vegetation: [3, vIcon],
    climate: [4, cIcon],
    modeloutput: [5, mIcon]
};


class SitesPane extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sites: props.sites,
            activeSite: props.activeSite
        };
        
        this.onTableInput = props.onTableInput.bind(this);
        this.handleRowClick = this.handleRowClick.bind(this);
    }
    
    handleRowClick(e) {
        //prevent duplicate click events from the img and td element listeners
        e.stopPropagation();
        let parent = e.target.parentNode;
        let feature_id = null;
        
        if (parent.tagName === "TD") {
            // received a click event from an icon in the row
            feature_id = parent.parentNode.getAttribute('data-element');
        }
        else {
            // otherwise the parent is already the TR element
            feature_id = parent.getAttribute('data-element');
        }

        this.onTableInput(feature_id);
    }
    
    componentWillReceiveProps(nextProps) {
        this.setState({
            sites: nextProps.sites,
            activeSite: nextProps.activeSite
        });
    }
    
    componentDidUpdate() {
        /* Scroll the actively viewed site to the top of the table */
        if (this.state.activeSite === null) {
            return;
        }
        const row = this.refs[this.state.activeSite.id];
        const rowParent = row.parentElement;
        rowParent.scrollTop = row.offsetTop - rowParent.offsetTop;
    }
    
    render() {
        let rows = [];
        let cssClasses = "";
        let f = null;

        for (let i = 0; i < this.props.sites.features.length; i++) {
            f = this.props.sites.features[i];
            //console.log(i);
            //console.log(this.props.sites.features[i]);
            if (f.id === this.state.activeSite.id) {
                cssClasses = "highlight";
            }
            else {
                cssClasses = "";
            }

            let categories = f.properties.measurement_categories.sort(function (a, b) {
                if (icons.hasOwnProperty(a) && icons.hasOwnProperty(b)) {
                    return icons[a][0] - icons[b][0];
                }
                else {
                    let unknownCategories = [];
                    if (!icons.hasOwnProperty(a)) {
                        unknownCategories.push(a);
                    }
                    if (!icons.hasOwnProperty(b)) {
                        unknownCategories.push(b);
                    }
                    throw Error("Unrecognized measurement categories: " + unknownCategories);
                }
            });
            
            let iconRow = [];
            for (let i = 0; i < categories.length; i++) {
                if (icons.hasOwnProperty(categories[i])) {
                    iconRow.push(<img className='measurement-icon' alt={icons[categories[i]][1]} src={icons[categories[i]][1]} key={icons[categories[i]][1]} onClick={this.handleRowClick} />);
                }
            }
            
            rows.push(<tr className={cssClasses} key={f.id + ": " + i}
                          ref={f.id} data-element={f.id} >
                      <td onClick={this.handleRowClick}>{f.id + ": " + f.properties.name}</td>
                      <td onClick={this.handleRowClick}>{f.properties.category}</td>
                      <td onClick={this.handleRowClick}>{iconRow}</td>
                      </tr>);
        }

        //console.log(rows);
        
        return (
            <div id='list' className="col-sm-5">
                <SitePreview activeSite={this.state.activeSite} />
                <table className="table">
                    <thead data-element='list-header'>
                        <tr>
                            <th>{"Listing " + rows.length + " of " + this.props.totalSites + " Sites"}</th>
                        </tr>
                        <tr>
                            <th>Site ID: Name</th>
                            <th>Site Category</th>
                            <th>Measurement Types</th>
                        </tr>
                    </thead>
                    <tbody data-element='list-rows'>
                        { rows }
                    </tbody>
                </table>
            </div>
        );
    }
}

class SitePreview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            images: [],
            activeSite: null
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            images: nextProps.images,
            activeSite: nextProps.activeSite
        });
    }
    
    render() {
        let prefix="/";
        if (process.env.REACT_APP_PREFIX) {
            prefix = process.env.REACT_APP_PREFIX;
        }
        
        if (this.state.activeSite) {
            let carouselImages = [];
            let carouselItems = [];
            let lifeZone = "N/A";
            const site = this.state.activeSite;

            if (site.geometry.coordinates.length === 3) {
                let elevation = site.geometry.coordinates[2];
                
                if (elevation > 11000) {
                    lifeZone = "Alpine";
                }
                else if (elevation >= 9000) {
                    lifeZone = "Sub-Alpine";
                }
                else if (elevation >= 7000) {
                    lifeZone = "Montane";
                }
                else if (elevation >= 5600) {
                    lifeZone = "Foothills";
                }
                else if (elevation >= 0) {
                    lifeZone = "Plains";
                }
            }
        
            let displayCategories = site.properties.measurement_categories.slice(0);
            for (let i = 0; i < displayCategories.length; i++) {
                displayCategories[i] = displayCategories[i][0].toUpperCase() + displayCategories[i].substr(1);
            }
            
            if (site.properties.links && site.properties.links.images) {
                carouselImages = site.properties.links.images;
            }
            
            for (let i = 0, imageInclude = null; i < carouselImages.length; i++) {
                try {
                    imageInclude = require("../assets/thumbs/" + carouselImages[i]);
                    carouselItems.push(
                        <Carousel.Item key={site.id + i} index={i}>
                            <img width={500} height={250} alt={carouselImages[i]}
                                 src={imageInclude}/>
                            }
                        </Carousel.Item>
                    );
                }
                catch (e) {
                    console.log("Unable to find photo: " + carouselImages[i]);
                }
            }
            
            let carousel = (
                        <Carousel controls={true}
                                  indicators={true}
                                  interval={3000}
                                  direction={'next'}>
                                  {carouselItems}
                        </Carousel>);
            
            if (carouselItems.length === 0) {
                carousel = (<div className="text-danger" style={{top: 50 + '%', height: 50 + '%', position: 'relative'}}>No photos available for this site</div>);
            }
            
            return (
                <div id='preview'>
                    <div className="col-sm-6" id='preview-image'>
                        {carousel}
                    </div>
                    <div className="col-sm-6" id='preview-body'>
                        <div>
                            <div>
                                <h4 style={{paddingTop: 0, marginTop: 0}}>
                                    {site.properties.id + ': ' + site.properties.name}
                                </h4>
                                <h5 className="location-sub-title"><b>{site.properties.research_theme}</b></h5>
                            </div>
                            <div style={{marginBottom: 5 + 'px'}}>
                                <b>Estimated Life Zone</b>
                                <div>{lifeZone}</div>
                            </div>
                            <div style={{marginBottom: 5 + 'px'}}>
                                <b>Site Category</b>
                                <div>{site.properties.category}</div>
                            </div>
                            <div style={{marginBottom: 5 + 'px'}}>
                                <b>Measurement Types</b>
                                <div>
                                    {displayCategories.join()}
                                </div>
                            </div>
                            <div className='col-sm-6' style={{marginBottom: 5 + 'px', paddingLeft: 0}}>
                                <b>Site Contact</b>
                                <div>{site.properties.contact.name}</div>
                            </div>
                            <div id='view-details' className='col-sm-6' style={{paddingLeft: 0, paddingRight: 15}}>
                                <Button bsStyle="primary"
                                        href={prefix + "sites/" + site.properties.id}
                                        target="_blank">View Details</Button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        else {
            return (
                <div id='preview' style={{marginRight: 0}}>
                    <h3 className='text-danger'>No sites match your criteria.</h3>
                </div>
            );
        }
    }
}

export default SitesPane;


// WEBPACK FOOTER //
// ./src/table/SitesPane.js